import { IOrganizationUserDTO } from 'data/dtos/authentication/i-organization-user-dto'
import { ICustomerDTO } from 'data/dtos/operation/i-customer-dto'
import { OrganizationFromState } from 'store/contracts'

const extractState = (organization: IOrganizationUserDTO | ICustomerDTO): OrganizationFromState => {
  return {
    id: organization.id as string,
    name: organization.corporateName as string,
    federalTaxId: organization.federalTaxId as string,
  }
}

export default extractState
